import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@atlas/ui';

import Field from 'common/Form/Field';

import CheckboxLabel from './CheckboxLabel';

const CheckboxField = ({ field, onChange }) => {
  const { autofocus, disabled, label, name, value } = field;
  const checked = Boolean(value);
  const changeHandler = useCallback(
    event => {
      onChange(event);
    },
    [onChange],
  );

  return (
    <Field options={field}>
      <Checkbox
        autofocus={autofocus}
        checked={checked}
        disabled={disabled}
        id={name}
        label={label}
        onChange={changeHandler}
      >
        <CheckboxLabel id={name} label={label} />
      </Checkbox>
    </Field>
  );
};

CheckboxField.propTypes = {
  field: PropTypes.shape({
    autofocus: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckboxField;
